import Map from './Map'
import enhance from './Map.enhancer'

export default enhance(Map)



// WEBPACK FOOTER //
// ./src/components/Map/index.js